import { render, staticRenderFns } from "./CookiesAlert.vue?vue&type=template&id=0fc7656a&"
import script from "./CookiesAlert.vue?vue&type=script&lang=js&"
export * from "./CookiesAlert.vue?vue&type=script&lang=js&"
import style0 from "./CookiesAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports